import { render, staticRenderFns } from "./ProductModifiersList.vue?vue&type=template&id=6046c991&scoped=true"
import script from "./ProductModifiersList.vue?vue&type=script&lang=js"
export * from "./ProductModifiersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6046c991",
  null
  
)

export default component.exports